import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dialog_on = _resolveComponent("dialog-on")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_dialog_on, {
      visible: _ctx.visible,
      "onUpdate:visible": _ctx.closeDialog,
      modal: "",
      class: "w-[20rem] md:w-[30rem] lg:w-[40rem]"
    }, {
      header: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("span", { class: "text-2xl font-semibold" }, "Sobre", -1)
      ])),
      default: _withCtx(() => [
        _cache[1] || (_cache[1] = _createElementVNode("article", { class: "block font-roboto" }, [
          _createElementVNode("p", null, [
            _createTextVNode(" Olá! Seja bem-vindo ao "),
            _createElementVNode("strong", null, "ViBi Flix"),
            _createTextVNode("! ")
          ]),
          _createElementVNode("br"),
          _createElementVNode("p", { class: "text-justify" }, " Este site foi desenvolvido durante a Residência Tecnológica em TIC 12, promovido pelo Irede, com o objetivo de criar uma plataforma integrada à API do TMDB. "),
          _createElementVNode("br"),
          _createElementVNode("p", { class: "text-justify" }, " Explore dados atualizados sobre filmes e séries populares, adicione ou remova favoritos e assista a trailers diretamente na plataforma. Aproveite e divirta-se! "),
          _createElementVNode("br"),
          _createElementVNode("p", null, [
            _createElementVNode("cite", null, [
              _createTextVNode("Projeto desenvolvido por "),
              _createElementVNode("a", {
                href: "https://github.com/thebiatriz",
                class: "hover:text-blue-500 underline",
                target: "_blank",
                rel: "noopener noreferrer"
              }, "Beatriz"),
              _createTextVNode(" e "),
              _createElementVNode("a", {
                href: "https://github.com/vikpires",
                class: "hover:text-blue-500 underline",
                target: "_blank",
                rel: "noopener noreferrer"
              }, "Vitor"),
              _createTextVNode(". ")
            ])
          ])
        ], -1))
      ]),
      _: 1
    }, 8, ["visible", "onUpdate:visible"])
  ]))
}